/**
 * FunnelCartBanner — slim green banner for the SideCart topBanner slot.
 *
 * Renders a small promotional banner (~20px tall) that signals the customer
 * selected an offer. It intentionally does not claim a discount was applied;
 * only the authoritative cart pricing response can make that assertion.
 */

import styled from '@emotion/styled';
import { useFunnelContext } from '@template-project/storefront-funnel';
import { useTranslation } from '@/lib/i18n';
import { SIDE_CART_FUNNEL_BANNER } from './i18.keys';

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 12px;
  background: linear-gradient(90deg, #4caf50, #66bb6a);
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1;
  flex-shrink: 0;
`;

const Icon = styled.span`
  font-size: 12px;
`;

export function FunnelCartBanner() {
  const { t } = useTranslation();
  const { assignedFunnelId } = useFunnelContext();

  if (!assignedFunnelId) return null;

  return (
    <Banner data-testid="funnel-cart-banner">
      <Icon>✦</Icon>
      {t(SIDE_CART_FUNNEL_BANNER)}
    </Banner>
  );
}
